"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.regexp.split");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _autoLogout = require("@/mixins/auto-logout/auto-logout");

var _location = require("@/api/location.api");

var _elementUi = require("element-ui");

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

var _permission = require("@/mixins/permission/permission");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LocationComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LocationComponent, _Mixins);

  var _super = _createSuper(LocationComponent);

  function LocationComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LocationComponent);
    _this = _super.apply(this, arguments);
    _this.locations = [];
    _this.selectedLocation = null;
    _this.currentPage = 1;
    _this.pageSize = 20;
    _this.totalData = 1;
    _this.isShowLocationModal = false;
    return _this;
  }

  (0, _createClass2.default)(LocationComponent, [{
    key: "created",
    value: function created() {
      if (!this.locationAPI) {
        this.locationAPI = new _location.LocationAPI({
          customerKey: this.$userInformation.customerKey || ''
        });
      }

      this.getAllLocations();
    }
  }, {
    key: "mounted",
    value: function mounted() {}
  }, {
    key: "indexMethod",
    value: function indexMethod(index) {
      return (this.currentPage - 1) * this.pageSize + index + 1;
    }
  }, {
    key: "handlePagination",
    value: function handlePagination(val, type) {
      if (type === 'sizeChange') {
        this.currentPage = 1;
        this.pageSize = val;
      }

      if (type === 'currentChange') {
        this.currentPage = val;
      }

      this.getAllLocations();
    }
  }, {
    key: "getAllLocations",
    value: function () {
      var _getAllLocations = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var pagination, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.loading = true;
                pagination = {
                  pageSize: this.pageSize,
                  currentPage: this.currentPage
                };
                _context.next = 4;
                return this.locationAPI.getAllLocations({
                  pagination: pagination
                });

              case 4:
                res = _context.sent;

                if (!(!res || res.failed)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", false);

              case 7:
                this.currentPage = res['pagination']['currentPage'] || 1;
                this.totalData = res['pagination']['totalData'] || 1;
                this.locations = res['data'];
                this.loading = false;

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getAllLocations() {
        return _getAllLocations.apply(this, arguments);
      }

      return getAllLocations;
    }()
  }, {
    key: "handleShowLocationDetails",
    value: function handleShowLocationDetails() {
      var _this2 = this;

      var locationData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.selectedLocation = null;
      this.locationAPI.getLocation({
        locationId: locationData['_id']
      }).then(function (res) {
        var data = _this2.helper.get(res, 'data', null);

        _this2.selectedLocation = data;
        _this2.isShowLocationModal = true;
      });
    }
  }, {
    key: "selectedLatlng",
    get: function get() {
      var latlng = [];

      if (this.selectedLocation['latlng1']) {
        latlng = this.selectedLocation['latlng1'].split(',');
      } else {
        latlng = this.selectedLocation['latlng2'].split(',');
      }

      return {
        'latitude': latlng[0],
        'longitude': latlng[1]
      };
    }
  }, {
    key: "selectedZone",
    get: function get() {
      var zone = [];
      this.selectedLocation['zones'].forEach(function (loc) {
        if (loc['code']) {
          zone.push(loc['code']);
        }
      });
      return zone.join(', ');
    } // duplicated

  }, {
    key: "isChina",
    get: function get() {
      return this.$userSetting['default10'];
    }
  }]);
  return LocationComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin, _autoLogout.AutoLogoutMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], LocationComponent.prototype, "$userSetting", void 0);
LocationComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LocationComponent',
  components: {
    'el-table': _elementUi.Table,
    'el-table-column': _elementUi.TableColumn,
    'el-pagination': _elementUi.Pagination,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog,
    'el-button': _elementUi.Button,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-input': _elementUi.Input,
    'map-world': _mapWorld.default
  }
})], LocationComponent);
var _default = LocationComponent;
exports.default = _default;